import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";

export const StringField = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 2,
}));

export const StringsLabel = styled("label")(() => ({
  color: "#308CDB",
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "0.875rem",
  lineHeight: "24px",
  marginBottom: 0,
}));

interface StringsTextProps {
  isEmpty?: boolean;
}
export const StringsText = styled("span")(({ isEmpty }: StringsTextProps) => ({
  color: isEmpty ? "#9CA6AF" : "#465869",
  fontWeight: isEmpty ? 400 : 600,
  fontSize: "0.875rem",
  fontFamily: "Manrope",
  lineHeight: "24px",
}));

export const CommodityWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: 10,
  flexWrap: "wrap",
}));

export const CommoditySpan = styled("span")(() => ({
  backgroundColor: "#EDF5FB",
  color: "#308CDB",
  padding: "0.25rem 0.5rem",
  borderRadius: 4,
}));

export const MilestoneWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: 24,
}));

export const MilestoneTitle = styled("span")(() => ({
  color: "#465869",
  fontSize: "1.125rem",
  fontWeight: 700,
  lineHeight: "24px",
  margin: "1rem 0 0.75rem 0",
}));

export const MilestoneField = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  paddingLeft: "1.1rem",
}));

export const CarrierInfoWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 12,
}));

export const InfoSpan = styled("span")(({ bold }: { bold?: boolean }) => ({
  display: "flex",
  alignItems: "center",
  gap: 4,

  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: bold ? 600 : 400,
  lineHeight: "20px",
  letterSpacing: bold ? "0.1px" : "0.25px",

  color: "#475467",
}));

export const CheckIcon = styled(AiOutlineCheck)(() => ({
  color: "#039855",
  fontSize: 18,
}));

export const CloseIcon = styled(AiOutlineClose)(() => ({
  fontSize: 18,
  color: "#D92D20",
}));

const styles = makeStyles(() => ({
  mt20: {
    margin: "20px 0 0 0",
  },
  listSubHeader: {
    textTransform: "uppercase",
    color: "#9CA6AF",
    font: "500 10px/12px Manrope",
    marginBottom: 5,
  },
  withInactiveButton: {
    width: "100%",
    // paddingLeft: 12,
    // marginTop: 32,
  },
  withoutInactiveButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    // marginTop: 32,
  },
  pt0: {
    paddingTop: 0,
  },
}));

export default styles;
